import { params, const_var} from '../reducer';
import * as cuComponent from '../building_component/componentReducer';
export const controls = {
    isCheckActiveTab:null
}
export const eventState= {
    controls:controls
}
const eventReducer = (state = eventState, action) => {
        const newState = { ...state };
        switch (action.type) {
        case "handleAccordionTab":  
            if(const_var.crmSetting.is_Edit==true && const_var.check_siding_material_price== true)
            {
                const_var.check_siding_material_price = false;
            }
            let newCont
            var sections = document.querySelectorAll('.accordion-type-2 .card')
            if(action.key !=undefined && action.key !="" && action.flag == undefined){
                if (action.value.currentTarget.parentNode.classList.contains("active") == true && const_var.isActiveSlide) {
                    action.value.currentTarget.parentNode.classList.remove('active');
                    controls.isCheckActiveTab = null
                    newCont =  controls.isCheckActiveTab
                } else {
                    sections = action.value.currentTarget.parentNode.parentNode.children;
                    for (let i = 0; i < sections.length; i++) {
                        sections[i].classList.contains("active")
                        sections[i].classList.remove('active');
                    }
                    controls.isCheckActiveTab = action.key
                    action.value.currentTarget.parentNode.classList.add('active')
                    newCont =  controls.isCheckActiveTab

                }
            }else{
                controls.isCheckActiveTab = null
                newCont =  controls.isCheckActiveTab

            }
            if(action.flag == "change" &&  document.getElementsByClassName('card-menu')!=undefined){
                controls.isCheckActiveTab = action.key
                newCont =  controls.isCheckActiveTab
                document.getElementsByClassName('card-menu')[1]?.classList.remove('active')
                document.getElementsByClassName('card-menu')[0]?.classList.add('active')
            }
            if(action.flag == "reset" &&  document.getElementsByClassName('card-menu')!=undefined){
                controls.isCheckActiveTab = action.key
                newCont =  controls.isCheckActiveTab
                let cardArr = document.getElementsByClassName('card-menu')
                for(let i = 0 ; i<=cardArr.length-1; i++){
                    cardArr[i].classList.remove('active')
                }
                const_var.activeTab = "buildingtypetab"
                document.getElementsByClassName('card-menu')[0]?.classList.add('active')
                document.getElementsByClassName('card-menu')[0].scrollIntoView(0,0)
            }
            if(action.flag == "statechange" &&  document.getElementsByClassName('card-menu')!=undefined){
                controls.isCheckActiveTab = "buildsizes"
                newCont =  controls.isCheckActiveTab
                let cardArr = document.getElementsByClassName('card-menu')
                for(let i = 0 ; i<=cardArr.length-1; i++){
                    cardArr[i].classList.remove('active')
                }
                document.getElementsByClassName('card-menu')[1]?.classList.add('active')
            }
            if (const_var.controls !== undefined) {
                 const_var.controls.target?.set(0, params.p_h / 2, 0);
             }

            if(action.key == "doorwindow" && const_var.selectedLeanType !== ""){
                if(const_var.selectedLeanType == "left"){
                    params.activeWall = 'G_L_L_F_W';
                    cuComponent.cameraFocusOnWall("", 'G_L_L_F_W');
                }
                if(const_var.selectedLeanType  == "right"){
                    params.activeWall = 'G_R_L_F_W';
                    cuComponent.cameraFocusOnWall("", 'G_R_L_F_W');
                }
                if(const_var.selectedLeanType  == "front"){
                    params.activeWall = 'G_F_L_F_W';
                    cuComponent.cameraFocusOnWall("", 'G_F_L_F_W');
                }
                if(const_var.selectedLeanType  == "back"){
                    params.activeWall = 'G_B_L_F_W';
                    cuComponent.cameraFocusOnWall("", 'G_B_L_F_W');
                }
            }            
            return {
                ...state,
                newCont
            } 
      }
    return newState;
  };

export default eventReducer;
